module.exports = __webpack_public_path__ + "static/media/order_icon6.c3391b8e.png";